<script setup lang="ts">
import DOMPurify from "dompurify";
import Modal from "@/components/Reusables/Modal/Modal.vue";
import { computed } from "vue";

const emits = defineEmits(["toggleModal"]);

const props = defineProps<{
  data: any;
}>();

const toggleModal = () => {
  emits("toggleModal");
};

const sanitizedText = computed(() => props.data.text.map((t: string | Node) => DOMPurify.sanitize(t)));
</script>

<template>
  <Modal
    :heading="props.data.title"
    size="w-3/6 h-fit"
    @toggle-modal="toggleModal">
    <div class="flex flex-col gap-4 p-4">
      <ul class="t-small flex list-disc flex-col gap-4">
        <li
          v-for="text in sanitizedText"
          :key="text"
          v-html="text" />
      </ul>
    </div>
  </Modal>
</template>
